// components/CustomModal.tsx
import React from "react";
import { Modal, Button, Form, Input, Typography } from "antd";
import ViewDetailsComponent from "./ViewDetailsComponent";
import EditForm from "./EditForm";

const { Title } = Typography;

type ModalType = "edit" | "view" | "delete" | "password" | null;

interface Props {
  modalType: ModalType;
  modalOpen: boolean;
  isSubmitting: boolean;
  setModalOpen: (open: boolean) => void;
  currentRow?: any;
  form: any;
  footerPassword?: string;
  setFooterPassword?: (val: string) => void;
  handlePasswordSubmit?: () => void;
  handleDelete?: () => void;
  handleUpdate?: () => void;
  handleValuesChange?: (changed: any, all: any) => void;
  isSubmitDisabled?: boolean;
  packageGroups?: any[];
}

const CustomModal: React.FC<Props> = ({
  modalType,
  modalOpen,
  isSubmitting,
  setModalOpen,
  currentRow,
  form,
  footerPassword = "",
  setFooterPassword = () => {},
  handlePasswordSubmit = () => {},
  handleDelete = () => {},
  handleUpdate = () => {},
  handleValuesChange = () => {},
  isSubmitDisabled = false,
  packageGroups = [],
}) => {
  const getModalTitle = () => {
    switch (modalType) {
      case "delete":
        return "Устгах";
      case "view":
        return "Дэлгэрэнгүй мэдээлэл";
      case "edit":
        return <Title level={3} style={{ margin: 0 }}>📅 Захиалга засах</Title>;
      case "password":
        return "Хөл дүн харах";
      default:
        return "";
    }
  };

  const getModalFooter = () => {
    if (modalType === "password") {
      return [
        <Button disabled={isSubmitting} key="cancel" onClick={() => setModalOpen(false)}>
          Хаах
        </Button>,
        <Button key="submit" type="primary" onClick={handlePasswordSubmit}>
          OK
        </Button>,
      ];
    }
    if (modalType === "view") {
      return [
        <Button key="close" onClick={() => setModalOpen(false)}>
          Хаах
        </Button>,
      ];
    }
    return null;
  };

  const renderModalContent = () => {
    if (modalType === "delete") {
      return (
        <Form form={form} onFinish={handleDelete} layout="vertical">
          <Form.Item
            name="password"
            label="Нууц код"
            rules={[{ required: true, message: "Нууц код оруулна уу!" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button disabled={isSubmitting} type="primary" htmlType="submit">
              Устгах
            </Button>
          </Form.Item>
        </Form>
      );
    }

    if (modalType === "password") {
      return (
        <Input.Password
          
          value={footerPassword}
          onChange={(e) => setFooterPassword(e.target.value)}
          placeholder="Нууц үгээ оруулна уу"
          onKeyDown={(e) => {
            if (e.key === "Enter") handlePasswordSubmit();
          }}
        />
      );
    }

    if (modalType === "view") {
      return <ViewDetailsComponent row={currentRow} />;
    }

    if (modalType === "edit") {
        return (
          <EditForm
            form={form}
            onFinish={handleUpdate}
            onValuesChange={handleValuesChange}
            currentRow={currentRow}
            isSubmitDisabled={isSubmitDisabled}
            packageGroups={packageGroups}
          />
        );
      }
      

    return null;
  };

  return (
    <Modal
      open={modalOpen}
      title={getModalTitle()}
      onCancel={() => setModalOpen(false)}
      footer={getModalFooter()}
      centered
      width={modalType === "edit" ? 960 : 520}
    >
      {renderModalContent()}
    </Modal>
  );
};

export default CustomModal;
